import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { User as FirebaseUser } from 'firebase/auth';
import type { User } from '@/types';

interface AuthState {
  user: FirebaseUser | null;
  userProfile: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  userProfile: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<FirebaseUser | null>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
      // NOTE: Do NOT set isLoading here. useAuth's handleUserChange manages
      // loading state explicitly via setLoading(false) after the Firestore
      // profile fetch completes. Setting it here caused ProtectedRoute to see
      // isAuthenticated+!userProfile+!isLoading before the profile was loaded,
      // triggering premature redirects (e.g. /processing → /plan-selection).
    },
    setUserProfile: (state, action: PayloadAction<User | null>) => {
      state.userProfile = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    logout: state => {
      state.user = null;
      state.userProfile = null;
      state.isAuthenticated = false;
      state.error = null;
    },
  },
});

export const { setUser, setUserProfile, setLoading, setError, logout } = authSlice.actions;
export default authSlice.reducer;
